module.exports = __webpack_public_path__ + "img/pod1.b7795c94.png";